import { isEmpty } from "lodash";
import { Constant } from "../../../constants/constant";

export function propsToInitialState(data) {
  const dataInit = { ...data };
  dataInit.nam = data?.nam || null;
  dataInit.phuongXa = data?.donViHanhChinh_Xa || null;
  dataInit.quanHuyen = data?.donViHanhChinh_Huyen || null;
  dataInit.tinhThanh = data?.donViHanhChinh_Tinh || Constant.TINHTHANH;
  return dataInit;
}

export function parseDataSave(value) {
  const dataSave = { ...value };
  dataSave.nam = value?.nam || 0;
  dataSave.maTinh = value?.tinhThanh?.maTinh || null;
  dataSave.maHuyen = value?.quanHuyen?.maHuyen || null;
  dataSave.maXa = value?.phuongXa?.maXa || null;
  return dataSave;
}
